module.exports = "/_next/static/images/GetHistory@2x-9f002e0fe68b36fa059afe7e9a539248.webp";